import React, { useState, useRef, useEffect } from "react";
import "../css/AvisoFlotante.css";

import avisoMedia from "../img/AvisoFlotante/instagram01.jpg";

const AVISO_LINK = "https://www.instagram.com/p/Db8mt49O7xD/";

function AvisoFlotante() {

    const [visible, setVisible] = useState(true);

    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });

    const dragRef = useRef({
        dragging: false,
        startX: 0,
        startY: 0
    });

    const handleMouseDown = (e) => {

        dragRef.current.dragging = true;

        dragRef.current.startX =
            e.clientX - position.x;

        dragRef.current.startY =
            e.clientY - position.y;

    };

    const handleMouseMove = (e) => {

        if (!dragRef.current.dragging) return;

        setPosition({

            x: e.clientX - dragRef.current.startX,

            y: e.clientY - dragRef.current.startY

        });

    };

    const handleMouseUp = () => {

        dragRef.current.dragging = false;

    };

    useEffect(() => {

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseup", handleMouseUp);

        return () => {

            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);

        };

    }, []);

    const abrirAviso = () => {

        const url =
            AVISO_LINK.trim() !== ""
                ? AVISO_LINK
                : avisoMedia;

        window.open(url, "_blank");

    };

    if (!visible) return null;

    return (

        <div
            className="esc-aviso-flotante"
            style={{
                right: `40px`,
                bottom: `40px`,
                transform: `translate(${position.x}px,${position.y}px)`
            }}
            onMouseDown={handleMouseDown}
        >

            <img
                src={avisoMedia}
                alt="Aviso"
                className="esc-aviso-media"
                onDoubleClick={abrirAviso}
            />

            <button
                className="esc-aviso-cerrar"
                onClick={() => setVisible(false)}
            >
                ✕
            </button>

        </div>

    );

}

export default AvisoFlotante;